import { baseTableConfig } from "~/utils/tables";
export default {
    ...baseTableConfig,
    items: [],
    fields: [
        {
            key: "id",
            label: "#",
            active: false,
            sorter: false,
            filter: false,
            _style: "width:5%",
        },
        {
            key: "client_id",
            label: "Client",
            active: false,
            sorter: false,
            filter: false,
            _style: "width:30%",
        },
        {
            key: "priority",
            label: "Priority",
            active: false,
            sorter: false,
            filter: false,
            _active: false,
        },
        {
            key: "percentage",
            label: "Percetange",
            active: true,
            sorter: false,
            filter: false,
            _active: false,
        },
        {
            key: "is_priority",
            label: "Is priority",
            active: true,
            sorter: false,
            filter: false,
            _style: "width:5%",
        },
        {
            key: "options",
            label: "Options",
            active: true,
            sorter: false,
            filter: false,
            _style: "width:5%",
        },
    ],
    order: "desc",
    rows: 5,
    page: 1,
    total_pages: 1,
    loading: false,
    hover: true,
    pagination: true,
    sorter: {
        external: true,
        resetable: true,
    },
    sorterValue: {},
    size: "sm",
    columnFilter: true,
    allFields: [],
    itemsPerPageSelect: true,
    export: null,
    columnFilter: {
        external: true,
        lazy: true,
    },
    responsive: true,
    columnFilterValue: {},
    itemSelected: null
}